import { required, useTranslate } from "ra-core";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { DateInput } from "@/components/admin/date-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { TextInput } from "@/components/admin/text-input";

import { todayIsoDate } from "../misc/formatDate";
import { foreignKeyMapping } from "./foreignKeyMapping";
import { contactOptionText, validateNoteRequired } from "./noteModel";

/**
 * The note form: text, date and (optionally) the record the note belongs to.
 * Shared by contacts and sponsorings.
 *
 * The labels are given explicitly because the resource in context is either
 * `contact_notes` or `sponsoring_notes`, while the catalog uses `notes`.
 */
export const NoteInputs = ({
  selectReference,
  reference,
}: {
  /** Show a picker for the contact/sponsoring the note belongs to */
  selectReference?: boolean;
  reference?: "contacts" | "sponsorings";
}) => {
  const translate = useTranslate();

  return (
    <div className="flex flex-col gap-3">
      <TextInput
        source="text"
        label={false}
        multiline
        rows={3}
        helperText={false}
        placeholder={translate("resources.notes.inputs.add_note")}
        validate={validateNoteRequired}
      />

      {selectReference && reference ? (
        <ReferenceInput
          source={foreignKeyMapping[reference]}
          reference={reference}
        >
          <AutocompleteInput
            label={
              reference === "contacts"
                ? "resources.notes.fields.contact_id"
                : "resources.notes.fields.sponsoring_id"
            }
            optionText={
              reference === "contacts" ? contactOptionText : undefined
            }
            helperText={false}
            validate={required()}
            modal
          />
        </ReferenceInput>
      ) : null}

      <DateInput
        source="date"
        label="resources.notes.fields.date"
        helperText={false}
        defaultValue={todayIsoDate()}
        className="w-44"
      />
    </div>
  );
};
